export const DEFAULT_PLACEHOLDER_FIELD_LABEL = 'Placeholder field';

export const SEARCH_TEMPLATE_SAVE_TOOLTIP_TEXT =
  'The search tree must be valid and all fields in the Template builder panel must be filled';
